module.exports = __webpack_public_path__ + "img/t-rex.8bb784d3.png";